<script lang="ts">
	import Toast from './Toast.svelte'
	import { toasts } from './toasts'
	import { flip } from 'svelte/animate'
	import { fade, fly } from 'svelte/transition'
</script>

<div class="max-w-form fixed top-0 right-0 z-50 mt-5 mr-5 flex w-full flex-col gap-4">
	{#each $toasts as toast (toast.id)}
		<div
			in:fly|local={{ y: -10, duration: 200 }}
			out:fade|local={{ duration: 200 }}
			animate:flip={{ duration: 200 }}
		>
			<Toast {toast} />
		</div>
	{/each}
</div>
